import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SearchLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { cx: 11, cy: 11, r: 6, stroke: "currentColor" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "m20 20-3-3" })] }) });
}
const SearchLight = forwardRef(_SearchLight);
export { SearchLight };
